import { addDays, parseISO } from 'date-fns';

import { CollectCapacityReminderType } from './CollectCapacityReminderConfigurator';

export function addSnooze(reminderType: CollectCapacityReminderType, untilDays: number): void {
    localStorage.setItem(reminderType, addDays(new Date(), untilDays).toISOString());
}

export function getSnoozedUntil(reminderType: CollectCapacityReminderType): Date | null {
    const snoozedUntilAsIsoString = localStorage.getItem(reminderType);

    if (!snoozedUntilAsIsoString) {
        return null;
    }

    const currentDate = new Date();
    const snoozedUntil = parseISO(snoozedUntilAsIsoString);

    // The snooze is obsolete, we can remove it
    if (snoozedUntil < currentDate) {
        localStorage.removeItem(reminderType);
        return null;
    }

    return snoozedUntil;
}
